export const welcome = 'AccountPage.welcome';
export const account = 'Header.UserMenu.account';
export const password = 'Header.UserMenu.password';
export const policyPrivacy = 'Header.UserMenu.policyPrivacy';
